import { Injectable } from '@angular/core';
import { FormBase, TextBox } from '@mapfre-design-library/src/public_api';
import { map } from 'rxjs/operators';
import { UserDataService } from './../../data-services/user-data.service';
import { Router } from '@angular/router';

@Injectable()
export class EditPhoneService {
  phoneNumber: string;
  label: string;

  constructor(
    private userDataService: UserDataService,
    public router: Router
  ) {}

  getInputs() {
    if (this.router.url === '/profile/edit-phone') {
      this.label = 'PHONE';
    } else {
      this.label = 'ENTER_PHONE';
    }
    return this.userDataService.$userData.pipe(
      map((userResponse) => {
        this.phoneNumber =
          userResponse.userDetails.phone &&
          userResponse.userDetails.phone.number !== '999-999-9999'
            ? userResponse.userDetails.phone.number
            : '';
        const inputs: FormBase<any>[] = [
          new TextBox({
            additionalClasses: 'form-control',
            inputType: 'phone',
            value: this.phoneNumber,
            key: 'accountPhone',
            minLength: 10,
            maxLength: 13,
            label: this.label,
            required: true,
            type: 'tel',
            validationMessageError: 'VALID_PHONE_NUMBER',
          }),
        ];
        return inputs;
      })
    );
  }
}
